import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';

import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { ImprimirMultiplePesosPitufoComponent } from './imprimir-pesos-pitufo.component';
import { ReplaceSemicolonPesosPipe } from 'src/app/pipes/replace-semicolon-pesos.pipe';
import { ImprimirPesosSharedModule } from '../../imprimirPesos/imprimir-pesos.module.share';




@NgModule({
    declarations: [
        ImprimirMultiplePesosPitufoComponent,
        ReplaceSemicolonPesosPipe,
    ],
    imports: [ 
        CommonModule,
        ImprimirPesosSharedModule,
        ButtonModule 
    ],
    exports: [ 
        ImprimirMultiplePesosPitufoComponent,
        ReplaceSemicolonPesosPipe,
     ],
    providers: [ImprimirMultipleService],
})
export class ImprimirPesosPitufoMultipleSharedModule {}